import { render, staticRenderFns } from "./requestLawWorkShare.vue?vue&type=template&id=140d747d&scoped=true"
import script from "./requestLawWorkShare.vue?vue&type=script&lang=js"
export * from "./requestLawWorkShare.vue?vue&type=script&lang=js"
import style0 from "./requestLawWorkShare.vue?vue&type=style&index=0&id=140d747d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140d747d",
  null
  
)

export default component.exports